import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const deleteOrder = async (orderId: string): Promise<boolean> =>
  axios.delete(`/management/order/removeorder?orderId=${orderId}`).then((res) => res?.data?.result)

type Props = {
  orderId: string
}

export const useManagementDeleteOrder = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['deleteOrder'],
    mutationFn: ({ orderId }: Props) => deleteOrder(orderId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Deleted order.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to delete order, please try again.')
      }
    },
    throwOnError: false
  })
